<style scoped lang="scss">

</style>

<template>
  <div>
    <Head title="Verticals" />
    <h1 class="mb-8 is-size-3 has-text-weight-bold">Verticals</h1>
    <div class="is-flex is-justify-content-flex-end mb-6 is-fullwidth">
      <Link class="button is-info" href="/verticals/create">
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;Vertical</span>
      </Link>
    </div>

    <card-component>
      <b-table
        striped
        backend-filtering
        backend-pagination
        backend-sorting
        @sort="onSort"
        @click="(row) => $inertia.get(`/verticals/${row.id}/edit`)"
        :data="verticals.data">

        <b-table-column label="Name" sortable searchable field="name">
          <template #searchable="{filters, column}">
            <b-input v-model="filters[column.field]" @input="search(filters)" placeholder="Search Vertical..."></b-input>
          </template>
          <template #default="{row}">
            <Link :href="`/verticals/${row.id}/edit`">{{ row.name }}</Link>
          </template>
        </b-table-column>

        <b-table-column label="Created" v-slot="{ row }" sortable field="created_at" numeric>
          {{ row.created_at | moment }}
        </b-table-column>
      </b-table>

      <laravel-pagination :data="verticals" :filters="filters"></laravel-pagination>
    </card-component>
  </div>
</template>

<script>
import CardComponent from "@/Shared/CardComponent";
import LaravelPagination from "@/Shared/LaravelPagination";
import debounce from 'lodash/debounce';
import _ from 'lodash'

export default {
  components: {LaravelPagination, CardComponent},
  props: {
    filters: Object,
    verticals: Object,
  },
  methods: {
    update: debounce(function(filters) {
      this.$inertia.get(this.verticals.path, {
        ..._.merge(this.filters, filters),
        page: this.verticals.current_page,
      }, {
        preserveState: true,
        replace: true,
      })
    }, 300),
    search(filters) {
      this.update(filters);
    },
    onSort(field, order) {
      this.update({ sort_field: field, sort_order: order,});
    },
  },
}
</script>
